































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";
import CityService from "../services/city.service";

@Component({
  components: {
    Menu,
    Footer,
  },
})
export default class FeedBack extends Vue {
  private service = new CityService();

  private brand: any = {};
  private message: any = null;

  private form: any = {};

  mounted() {
    this.service.getBrand(this.$route.params.id).then((res) => {
      this.brand = res.data;
    });
  }

  submit() {
    this.service.sendFeedback(this.form).then((res) => {
      this.message = res.data;
    });
  }
}
